(function() {
    'use strict';

    angular
        .module('app.directive')
        .directive('focus', focus);

    function focus() {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element) {
            element.focus();
        }
    }

})();